export default "__VITE_ASSET__DujnJiP2__"